import Main from './Main'

export default [
  {
    path: '/website', component: Main, name: 'website.main', children: [
      {path: 'sites', component: () => import('@/components/sites/components/ListaSites.vue'), name: 'website.sites.lista'},
      {path: 'sites/:id', component: () => import('@/components/sites/components/Site.vue'), name: 'website.sites.show'},
      {
        path: 'banners',
        name: 'website.banners',
        component: () => import('./components/banners/components/List.vue')
      },
      {
        path: 'paginas',
        name: 'website.paginas',
        component: () => import('./components/paginas/components/List.vue')
      },
      {
        path: 'menus',
        name: 'website.menus.page',
        component: () => import('./components/menus/components/List.vue')
      },
      { path: 'blog/posts', component: () => import('@/components/blog/components/ListaPosts'), name: 'website.blog.posts' },
      { path: 'blog/categorias', component: () => import('@/components/blog/components/categorias/components/List.vue'), name: 'website.blog.categorias' }
    ]
  }
]
